import { render } from "./Loan_Penalties.vue?vue&type=template&id=315ca0aa&scoped=true"
import script from "./Loan_Penalties.vue?vue&type=script&lang=js"
export * from "./Loan_Penalties.vue?vue&type=script&lang=js"

import "./Loan_Penalties.vue?vue&type=style&index=0&id=315ca0aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315ca0aa"]])

export default __exports__